module.exports = __webpack_public_path__ + "img/plusbtn.6666379b.svg";